<!--专题讲座-->
<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <butn
        class="btn-wrapper"
        v-permission="'topicLecture:import'"
        btntype="primary"
        title="导入专题讲座记录"
        @click="importShow()"
      ></butn>
      <div class="search_right">
        <Search class="search-wrapper" @search="searchHandle" :lectureTypes="lectureTypes" topicPlacehodler="请输入讲座主题并选择" @changeTopic="changeTopic" />
      </div>
    </div>
    <TopicHeader :type="1" :info="currentTopicInfo"/>
    <!--表格内容栏-->
    <div class="topicLecture_table">
      <Tables :data="dataList" @onTrainInfo="onTrainInfo"/>
    </div>
    <!--分页栏-->
    <div class="RCPagination">
      <RCPagination ref="pagination" v-model="dataList" :api="api" :startRequest="false" />
    </div>
    <ImportDia
      @closeImport="closeImport"
      :importInfo="importInfo"
      v-if="importInfo.show"
    />
    <TrainInfoDia ref="trainInfo" :type="1"/>
  </div>
</template>
<script>
import butn from "@/components/button/index";
import RCPagination from "@/components/pagination/paginationManage";
import ImportDia from "./components/import.vue";

import { getTopicLecturePageNew } from "@/api/topicLecture";
import Search from "@/pages/topicLecture/components/search.vue";
import Tables from "@/pages/topicLecture/components/table.js";
import TrainInfoDia from "@/pages/topicLecture/components/trainInfoDia.vue";
import TopicHeader from "@/pages/topicLecture/components/topicHeader.vue"

export default {
  name: "topicLecture",
  components: { butn, Tables, Search, RCPagination, ImportDia, TrainInfoDia, TopicHeader },
  data() {
    return {
      size: "small",
      dataList: [],
      api: getTopicLecturePageNew,
      dataname: "",
      importInfo: {
        show: false,
        title: "",
        nowType: 0,
      },
      lectureTypes: [1, 2],
      currentTopicInfo: {}
    };
  },
  created() {
    this.$nextTick(() => {
      this.searchHandle();
    })
  },
  methods: {
    //搜索
    searchHandle(data = {}) {
      this.dataname = {...data, lectureTypes: this.lectureTypes};
      if (!data.lectureId) {
        this.currentTopicInfo = {};
      }
      this.$refs["pagination"].search(this.dataname);
    },
    importShow() {
      this.importInfo = {
        show: true,
        title: "专题讲座导入"
      };
    },
    closeImport() {
      this.importInfo.show = false;
    },

    onTrainInfo(row) {
      this.$refs.trainInfo.show({
        userId: row.uuid,
        lectureTypes: this.lectureTypes
      });
    },

    changeTopic(item) {
      this.currentTopicInfo = item;
    }
    
  }
};
</script>
<style lang="scss" scoped>
/deep/.topicLecture_table .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #FFFFFF;
}
</style>
